<template>
  <Transition name="modal-popup">
    <div v-if="open" class="modal-mask" @click.self="handleClose">
      <div ref="cardRef" class="modal-card glass">
        <button class="modal-close close" @click="handleClose">×</button>
        <div class="header">
          <h3 class="title">重置密码</h3>
          <p class="desc">请输入您注册时使用的邮箱地址，我们将发送重置后的密码到您的邮箱</p>
        </div>
        <form @submit.prevent="handleSubmit" class="contact-form">
          <div class="form-row">
            <div class="form-item">
              <input
                  v-model="form.email"
                  type="email"
                  required
                  placeholder="请输入注册时的邮箱"
              />
            </div>
          </div>
          <div class="btn-wrap">
            <button class="submit-btn" :disabled="loading">
              {{ loading ? '重置中...' : '重置密码' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import {ref, reactive, defineProps, defineEmits} from 'vue'
import request from "@/api/request";
import showToast from "@/utils/toast";

defineProps({
  open: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:open'])

const cardRef = ref(null)
const loading = ref(false)
const form = reactive({
  email: ''
})

const handleClose = () => {
  emit('update:open', false)
  loading.value = false
  form.email = ''
}
const handleSubmit = async ()=> {
  loading.value = true
  try {
    const response = await request.post('/v1/api/resetPassword', {
      username: form.email
    })
    const resp = response.data;
    if (resp.responseCode === '0000') {
      showToast("重置密码已发送至您的邮箱", "success")
      setTimeout(handleClose, 1400)
    } else {
      showToast(resp.responseDesc)
    }
  } catch (e) {
    showToast(e.message)
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 9999;
  padding: 20px;
  box-sizing: border-box;
}

.modal-card {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 720px;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  border-radius: 18px;
  padding: 36px 100px;
  box-sizing: border-box;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
}

/* 从上方滑入到中心动画 */
.modal-popup-enter-from .modal-card {
  transform: translate(-50%, -120%);
  opacity: 0;
}
.modal-popup-enter-active .modal-card {
  transition: all 0.32s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.modal-popup-enter-to .modal-card {
  transform: translate(-50%, -50%);
  opacity: 1;
}

.modal-popup-leave-from .modal-card {
  opacity: 1;
}
.modal-popup-leave-to .modal-card {
  transform: translate(-50%, -120%);
  opacity: 0;
}
.modal-popup-leave-active .modal-card {
  transition: all 0.24s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.modal-close {
  position: absolute;
  top: 16px;
  right: 18px;
  line-height: 1;
  padding: 0;
  font-size: var(--laputa-fontsize-28);
}
.header {
  margin-bottom: 28px;
  text-align: center;
}
.title {
  font-size: var(--laputa-fontsize-28);
  font-weight: 700;
  margin: 0 0 8px;
  color: var(--laputa-common-font-color);
}
.desc {
  font-size: var(--laputa-fontsize-15);
  color: var(--laputa-common-secondary-font-color);
  margin: 0;
}

.contact-form {
  width: 100%;
}

.form-row {
  display: flex;
  gap: 24px;
}

.form-item {
  flex: 1;
  margin-bottom: 20px;
}

/* 输入框，文字居中 */
.form-item input {
  width: 100%;
  height: 48px;
  padding: 0 20px;
  border: 1px solid var(--laputa-glass-header-separator);
  border-radius: 999px;
  font-size: var(--laputa-fontsize-14);
  background: var(--laputa-glass-background);
  color: var(--laputa-common-thirdary-font-color);
  box-sizing: border-box;
  transition: border 0.2s;
  text-align: center;
}

.form-item input:focus {
  outline: none;
  border-color: var(--laputa-primary);
  background: var(--laputa-body-background);
}

.btn-wrap {
  text-align: center;
  margin-top: 8px;
}

.submit-btn {
  width: 220px;
  height: 50px;
  border-radius: 999px;
  border: none;
  background: var(--laputa-btn-background);
  color: var(--laputa-common-inverse-font-color);
  font-size: var(--laputa-fontsize-15);
  cursor: pointer;
  transition: opacity 0.2s;
}
.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 992px) {
  .modal-card {
    padding: 28px 24px;
  }
  .title {
    font-size: 28px;
  }
  .form-row {
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .modal-mask {
    padding: 12px;
  }
  .modal-card {
    padding: 24px 20px;
    border-radius: 14px;
    max-height: calc(100vh - 24px);
  }
  .title {
    font-size: 24px;
  }
  .header {
    margin-bottom: 20px;
  }
  .form-row {
    flex-direction: column;
    gap: 0;
  }
  .submit-btn {
    width: 100%;
  }
}
</style>
